import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Button, Form, Input, Picker, Toast} from "antd-mobile";
import dayjs from "dayjs";
import moment from "moment";
import {queryInstallment} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

type listDataItem = {
    period: string,
    principal: string,
    fees: string,
    repaymentDate: string,
    amount: string
}

const Calculator = () => {
    const {t} = useTranslation();
    const [form] = Form.useForm();
    const [list, setList] = useState<listDataItem[]>([]);
    const loanDaysList = [
        {
            label: t('create_order_loan_3_months_no_rate'), // 使用翻译
            value: 1
        },
        {
            label: t('create_order_loan_6_months_24_no_rate'), // 使用翻译
            value: 2
        },
        // {
        //     label: t('create_order_loan_6_months_12'), // 使用翻译
        //     value: 3
        // },
        {
            label: t('create_order_loan_4_months_no_rate'), // 使用翻译
            value: 4
        },
        {
            label: t('create_order_loan_5_months_no_rate'), // 使用翻译
            value: 5
        },
        {
            label: t('create_order_loan_1_months_no_rate'), // 使用翻译
            value: 6
        },
        {
            label: t('create_order_loan_2_months_no_rate'), // 使用翻译
            value: 7
        },
        {
            label: t('create_order_loan_days_8'), // 使用翻译
            value: 8
        }
    ]

    useEffect(() => {
        document.title = 'Calculator'
    }, [])
    const _getcountryDesc = (val: any) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                return item.label
            }
        }
        return t('create_order_select');
    }
    const btnReSetAction = () => {
        form.resetFields();
        setList([])
    }
    const onFinish = (values: any) => {
        console.log(values)
        if (values['contractDate']) {
            values['contractDate'] = moment(values['contractDate']).format('YYYY-MM-DD')
        } else {
            values['contractDate'] = dayjs().format('YYYY-MM-DD')
        }
        if (values['loanDaysType']) {
            values['loanDaysType'] = values['loanDaysType'][0];
        }
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        queryInstallment(values).then((res:any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                if (Array.isArray(res.data)) {
                    const temList: listDataItem[] = [{
                        period: t('home_periods'),
                        principal: t('loan_principal'),
                        fees: t('loan_fees'),
                        repaymentDate: t('order_repayment_date'),
                        amount: t('loan_repayment_amount'),
                    }];
                    res.data.forEach((item: any, index: number) => {
                        temList.push({
                            period: (index +1).toString(),
                            principal: item.principal,
                            fees: item.interest,
                            repaymentDate: moment(item.dueDate).format('YYYY-MM-DD'),
                            amount: (parseFloat(item.principal) + parseFloat(item.interest)).toFixed(2),
                        })
                    })
                    setList(temList)
                } else {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                }
            }
        })
    }

    // const _renderListUIItem = (data: listDataItem, index: number) => {
    //     return <div key={index} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", padding: '10px 5px', textAlign: "center"}}>
    //         <span style={{flex: 1}}>{data.period}</span>
    //         <span style={{flex: 3}}>{data.repaymentDate}</span>
    //         {/*<span style={{flex: 2}}>{data.principal}</span>*/}
    //         {/*<span style={{flex: 2}}>{data.fees}</span>*/}
    //         <span style={{flex: 3}}>{data.amount}</span>
    //     </div>
    // }

    const _renderMonthlySupply = (data: listDataItem) => {
        return <div style={{width: '80%', display: "flex", flexDirection: "column", alignItems: "center", marginTop: 10, borderRadius: 8, padding: '20px 0', backgroundColor: '#F5F6FA'}}>
            <span style={{fontSize: 16, fontWeight: 400}}>{t('calculator_monthly_supply')}</span>
            <span style={{fontSize: 25, fontWeight: "bold", marginTop: 10}}>{data.amount}</span>
        </div>
    }

    return (
        <div style={{width: '100%', height: '100%', display: "flex", flexDirection: "column"}}>
            <div>
                <Form
                    onFinish={onFinish}
                    mode={'card'}
                    form={form}
                    requiredMarkStyle='asterisk'
                    footer={<div style={{display: "flex", flexDirection: "row"}}>
                        <Button style={{marginRight: 20}} shape='rounded' onClick={btnReSetAction} block color='primary' size='middle'>{t('calculator_reset')}</Button>
                        <Button shape='rounded' type='submit' block color='primary' size='middle'>{t('calculator_btn_submit')}</Button>
                    </div>}>
                    <Form.Item name='price' label={t('create_order_order_price')} rules={[{ required: true, message: t('create_order_required') }]}>
                        <Input type={"number"} placeholder={t('create_order_required')} />
                    </Form.Item>
                    <Form.Item name='downPayment' label={t('create_order_down_payment')} rules={[{ required: true, message: t('create_order_required') }]}>
                        <Input type={"number"} placeholder={t('create_order_required')} />
                    </Form.Item>
                    {/*<Form.Item*/}
                    {/*    name='contractDate'*/}
                    {/*    label={t('create_order_contract_date')}*/}
                    {/*    trigger='onConfirm'*/}
                    {/*    onClick={(e, datePickerRef) => {*/}
                    {/*        datePickerRef.current?.open();*/}
                    {/*    }}*/}
                    {/*    rules={[{ required: true, message: t('create_order_required') }]}>*/}
                    {/*    <DatePicker>*/}
                    {/*        {value => value ? dayjs(value).format('YYYY-MM-DD') : t('create_order_select_date')}*/}
                    {/*    </DatePicker>*/}
                    {/*</Form.Item>*/}
                    <Form.Item
                        name='loanDaysType'
                        label={t('create_order_loan_days')}
                        trigger='onConfirm'
                        onClick={(e, pickerRef) => {
                            pickerRef.current?.open();
                        }}
                        rules={[{ required: true, message: t('create_order_required') }]}>
                        <Picker columns={[loanDaysList]}>
                            {value => value ? _getcountryDesc(value) : t('create_order_required')}
                        </Picker>
                    </Form.Item>
                </Form>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                {list.length > 1 ? _renderMonthlySupply(list[2]) : null}
            </div>
        </div>
    )
}
export default Calculator
